var fi = {
	modal_header_button_close: "Sulje"
};
var sv = {
	modal_header_button_close: "Stäng"
};
var en = {
	modal_header_button_close: "Close"
};
var translations = {
	fi: fi,
	sv: sv,
	en: en
};

export { translations as default, en, fi, sv };
//# sourceMappingURL=translations.js.map
